<script>
  import { onDestroy, onMount } from "svelte";
  import ItemResponse from "./ItemResponse.svelte";
  import { Collapse } from "sveltestrap";
  
  export let annotation,
    inputFocusAction,
    inputBlurAction,
    updateAnnotation,
    afterDelete;

  let showTextLine = annotation.text?.map(() => true) || [];
  let showLayout = annotation.text?.length <= 1;
  let showBoxStyle = false;
  let showAnchor = annotation.text?.length <= 1;
  onMount(() => {
    showTextLine = annotation.text?.map(() => true) || [];
    showLayout = true;
    showBoxStyle = false;
  });
  onDestroy(() => {});
</script>

<!-- name -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="text"
    title="Name"
    token="name"
    {inputFocusAction}
    {inputBlurAction}
    value={annotation.name || ""}
    changeAction={(event) => {
      updateAnnotation(event, "annotation.name", annotation);
    }}
  />
</div>

<!-- data link -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-row">
    <h3
      class="h-sub handle-collapse"
      on:click={() => {
        showAnchor = !showAnchor;
      }}
    >
      <i class={`bi bi-caret-${showAnchor ? "down-fill" : "right"} me-1`} /> Data
      link
    </h3>
  </div>
</div>

{#if showAnchor}
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="data-object"
      title="Data mark to link"
      token="datum"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.anchor?.dataItem}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.dataAnchor", annotation);
      }}
    />
  </div>
  {#if annotation.anchor?.dataItem}
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="orient"
        title="Anchor from mark"
        token="orient"
        {inputFocusAction}
        {inputBlurAction}
        tblr9pos={true}
        topBottom={false}
        leftRight={false}
        value={annotation.anchor?.positionOrient}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.orient", annotation);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="anchor"
        title="Anchor to text"
        token="anchor"
        {inputFocusAction}
        {inputBlurAction}
        mse3pos={true}
        value={annotation.anchor?.anchorAlign}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.anchor", annotation);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="inline-check"
        title="Use tick"
        token="tick"
        {inputFocusAction}
        {inputBlurAction}
        value={annotation.anchor?.callout === "yes"}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.tick", annotation);
        }}
      />
    </div>
    {#if annotation.anchor?.callout === "yes"}
      <!-- from-dx -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="number"
          title="Tick X position from mark (px)"
          token="from-dx"
          {inputFocusAction}
          {inputBlurAction}
          value={annotation.anchor?.from?.dx || 0}
          changeAction={(event) => {
            updateAnnotation(event, "annotation.tick.from.dx", annotation);
          }}
        />
      </div>
      <!-- from-dy -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="number"
          title="Tick Y position from mark (px)"
          token="from-dy"
          {inputFocusAction}
          {inputBlurAction}
          value={annotation.anchor?.from?.dy || 0}
          changeAction={(event) => {
            updateAnnotation(event, "annotation.tick.from.dy", annotation);
          }}
        />
      </div>
      <!-- to-dx -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="number"
          title="Tick X position to text (px)"
          token="to-dx"
          {inputFocusAction}
          {inputBlurAction}
          value={annotation.anchor?.to?.dx || annotation.dx}
          changeAction={(event) => {
            updateAnnotation(event, "annotation.tick.to.dx", annotation);
          }}
        />
      </div>
      <!-- to-dy -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="number"
          title="Tick Y position to text (px)"
          token="to-dy"
          {inputFocusAction}
          {inputBlurAction}
          value={annotation.anchor?.to?.dy || annotation.dy}
          changeAction={(event) => {
            updateAnnotation(event, "annotation.tick.to.dy", annotation);
          }}
        />
      </div>
      <!-- cornering -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="select"
          title="Tick cornering"
          token="tick-cornering"
          {inputFocusAction}
          {inputBlurAction}
          value={annotation.anchor?.cornering || "straight"}
          options={[
            "left-top",
            "left-bottom",
            "right-top",
            "right-bottom",
            "straight",
          ]}
          optionNames={[
            "Left-top",
            "Left-bottom",
            "Right-top",
            "Right-bottom",
            "No cornering",
          ]}
          changeAction={(event) => {
            updateAnnotation(event, "annotation.tick.cornering", annotation);
          }}
        />
      </div>
    {/if}
  {/if}
{/if}

<div class="pane-divider" />

<!-- layout -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-row">
    <h3
      class="h-sub handle-collapse"
      on:click={() => {
        showLayout = !showLayout;
      }}
    >
      <i class={`bi bi-caret-${showLayout ? "down-fill" : "right"} me-1`} /> Layout
    </h3>
  </div>
</div>
{#if showLayout}
  <!-- width -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="width"
      title="Width"
      token="width"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.width}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.width", annotation);
      }}
    />
  </div>

  <!-- height -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="height"
      title="Height"
      token="height"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.height}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.height", annotation);
      }}
    />
  </div>

  {#if annotation.anchor?.dataItem}
    <!-- x -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="unitNumber"
        title="Relative X position (dx)"
        token="dx"
        {inputFocusAction}
        {inputBlurAction}
        value={annotation.dx}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.dx", annotation);
        }}
      />
    </div>

    <!-- y -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="unitNumber"
        title="Relative Y position (dy)"
        token="dy"
        {inputFocusAction}
        {inputBlurAction}
        value={annotation.dy}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.dy", annotation);
        }}
      />
    </div>
  {:else}
    <!-- x -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="unitNumber"
        title="X position"
        token="x"
        {inputFocusAction}
        {inputBlurAction}
        value={annotation.x}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.x", annotation);
        }}
      />
    </div>

    <!-- y -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="unitNumber"
        title="Y position"
        token="y"
        {inputFocusAction}
        {inputBlurAction}
        value={annotation.y}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.y", annotation);
        }}
      />
    </div>

    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="orient"
        title="Position orient"
        token="position-orient"
        {inputFocusAction}
        {inputBlurAction}
        tblr9pos={true}
        topBottom={false}
        leftRight={false}
        value={annotation.anchor?.positionOrient}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.orient", annotation);
        }}
      />
    </div>

    <!-- dx -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="unitNumber"
        title="Relative X position (dx)"
        token="dx"
        {inputFocusAction}
        {inputBlurAction}
        value={annotation.dx}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.dx", annotation);
        }}
      />
    </div>

    <!-- dy -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="unitNumber"
        title="Relative Y position (dy)"
        token="dy"
        {inputFocusAction}
        {inputBlurAction}
        value={annotation.dy}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.dy", annotation);
        }}
      />
    </div>
  {/if}

  <!-- axis assist -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="inline-check"
      title="Axis assitance"
      token="axisAssist"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.axisAssist}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.axisAssist", annotation);
      }}
    />
  </div>

  <!-- externalization -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="inline-check"
      title="Externalize"
      token="external"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.visibility?.externalize}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.external", annotation);
      }}
    />
  </div>

  <!-- If externalized: numbering -->
  {#if annotation.visibility?.externalize !== undefined}
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="inline-check"
        title="Numbering"
        token="numbering"
        {inputFocusAction}
        {inputBlurAction}
        value={annotation.visibility?.externalize?.numbering}
        changeAction={(event) => {
          updateAnnotation(event, "annotation.numbering", annotation);
        }}
      />
    </div>
  {/if}

  <!-- rotate -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="angle"
      title="Rotate"
      token="rotate"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.angle}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.rotate", annotation);
      }}
    />
  </div>
{/if}

<div class="pane-divider" />

<!-- per text -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-row">
    <h3 class="h-sub">Text lines</h3>
  </div>
</div>
{#if annotation.text.length > 0}
  {#each annotation.text as text, ti}
    <div class="dupo-menu-pane">
      <div class="dupo-menu-pane-row">
        <div
          class="menu-second-level handle-collapse"
          on:click={() => {
            showTextLine[ti] = !showTextLine[ti];
            if (showTextLine[ti]) {
              showLayout = false;
              showBoxStyle = false;
            }
          }}
        >
          <i
            class={`bi bi-caret-${
              showTextLine[ti] ? "down-fill" : "right"
            } me-1`}
          />Text line {ti + 1}
        </div>
      </div>
    </div>
    <Collapse isOpen={showTextLine[ti]}>
      <!-- content -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="longText"
          title="Content"
          token={`annotation-text-${ti}-text`}
          {inputFocusAction}
          {inputBlurAction}
          value={text.text || ""}
          changeAction={(event) => {
            updateAnnotation(event, `annotation.text.${ti}.text`, annotation);
          }}
        />
      </div>

      <!-- alignment -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="textAlign"
          title="Text align"
          token={`annotation-text-${ti}-textAlign`}
          {inputFocusAction}
          {inputBlurAction}
          value={text.align}
          changeAction={(event) => {
            updateAnnotation(
              event,
              `annotation.text.${ti}.textAlign`,
              annotation
            );
          }}
        />
      </div>

      <!-- line-height -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="size"
          title="Line Height (%)"
          token={`annotation-text-${ti}-lineHeight`}
          {inputFocusAction}
          {inputBlurAction}
          value={annotation.lineHeight}
          changeAction={(event) => {
            updateAnnotation(
              event,
              `annotation.text.${ti}.lineHeight`,
              annotation
            );
          }}
        />
      </div>

      <!-- font size -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="fontSize"
          title="Font size"
          token={`annotation-text-${ti}-fontSize`}
          {inputFocusAction}
          {inputBlurAction}
          value={text.fontSize || 16}
          changeAction={(event) => {
            updateAnnotation(
              event,
              `annotation.text.${ti}.fontSize`,
              annotation
            );
          }}
        />
      </div>

      <!-- font weight -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="fontWeight"
          title="Font weight"
          token={`annotation-text-${ti}-fontWeight`}
          {inputFocusAction}
          {inputBlurAction}
          value={text.fontWeight}
          changeAction={(event) => {
            updateAnnotation(
              event,
              `annotation.text.${ti}.fontWeight`,
              annotation
            );
          }}
        />
      </div>

      <!-- color -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="color"
          title="Font color"
          token={`annotation-text-${ti}-color`}
          {inputFocusAction}
          {inputBlurAction}
          value={text.color || "rgba(0,0,0,1)"}
          changeAction={(event) => {
            updateAnnotation(event, `annotation.text.${ti}.color`, annotation);
          }}
        />
      </div>

      <!-- opacity -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="opacity"
          title="Font opacity"
          token={`annotation-text-${ti}-opacity`}
          {inputFocusAction}
          {inputBlurAction}
          value={text.opacity || 1}
          changeAction={(event) => {
            updateAnnotation(
              event,
              `annotation.text.${ti}.opacity`,
              annotation
            );
          }}
        />
      </div>

      <!-- overflow -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="textOverflow"
          title="Text overflow"
          token={`annotation-text-${ti}-overflow`}
          {inputFocusAction}
          {inputBlurAction}
          value={text.overflow}
          changeAction={(event) => {
            updateAnnotation(
              event,
              `annotation.text.${ti}.overflow`,
              annotation
            );
          }}
        />
      </div>

      <!-- todo: delete this line -->
      <div class="dupo-menu-pane mb-2">
        <div class="dupo-menu-pane-button-row">
          <button
            on:click={(event) =>
              updateAnnotation("delete", `annotation.text.${ti}`, annotation)}
            ><i class="bi bi-eraser me-1" /> Delete this line</button
          >
        </div>
      </div>

      <div class="pane-divider" />
    </Collapse>
  {/each}
{/if}
<!-- Add a new line -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-button-row">
    <button
      on:click={(event) =>
        updateAnnotation("duplicate", "annotation.text", annotation)}
      ><i class="bi bi-plus-circle me-1" /> Add a new text line</button
    >
  </div>
</div>

<div class="pane-divider" />
<!-- Box styling -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-row">
    <h3
      class="h-sub handle-collapse"
      on:click={() => {
        showBoxStyle = !showBoxStyle;
      }}
    >
      <i class={`bi bi-caret-${showBoxStyle ? "down-fill" : "right"} me-1`} /> Box
      styling
    </h3>
  </div>
</div>
<Collapse isOpen={showBoxStyle}>
  <!-- padding top/bottom/left/right -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="boxPadding"
      title="Padding"
      token="padding"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.box?.padding}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.box.padding", annotation);
      }}
    />
  </div>

  <!-- radius -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="number"
      title="Radius"
      token="radius"
      {inputFocusAction}
      {inputBlurAction}
      min={0}
      value={annotation.box?.radius}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.box.radius", annotation);
      }}
    />
  </div>

  <!-- stroke color -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="color"
      title="Stroke color"
      token="stroke"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.box?.stroke || "rgba(0,0,0,1)"}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.box.stroke", annotation);
      }}
    />
  </div>

  <!-- stroke width -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="width"
      title="Stroke width"
      token="strokeWidth"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.box?.strokeWidth}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.box.strokeWidth", annotation);
      }}
    />
  </div>

  <!-- stroke style -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="strokeStyle"
      title="Stroke style"
      token="strokeStyle"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.box?.strokeWidth}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.box.strokeStyle", annotation);
      }}
    />
  </div>

  <!-- stroke opacity -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="opacity"
      title="Stroke opacity"
      token="strokeOpacity"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.box?.strokeOpacity || 1}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.box.strokeOpacity", annotation);
      }}
    />
  </div>

  <!-- fill -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="color"
      title="Fill color"
      token="fill"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.box?.fill || "rgba(0,0,0,1)"}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.box.fill", annotation);
      }}
    />
  </div>

  <!-- opacity -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="opacity"
      title="Opacity"
      token="opacity"
      {inputFocusAction}
      {inputBlurAction}
      value={annotation.box?.opacity || 1}
      changeAction={(event) => {
        updateAnnotation(event, "annotation.box.opacity", annotation);
      }}
    />
  </div>
</Collapse>

<!-- lock -->
<div class="pane-divider" />
<div class="dupo-menu-pane pt-2 mb-2">
  <ItemResponse
    type="lock"
    tooltipMessage="Prevent suggesting responsive alternatives that make changes to this annotation (not position). Element-Lock applies to its source or target design(s)."
    title="Lock this annotation"
    token={"annotation-lock"}
    value={annotation.lock}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateAnnotation(event, "lock", annotation);
    }}
  />
  <div class="dupo-menu-pane-row">
    <p class="text-sm">Does not to the position of this annotation.</p>
  </div>
</div>
<div class="dupo-menu-pane">
  <ItemResponse
    type="lock"
    tooltipMessage="Prevent suggesting responsive alternatives that externalize this annotation. Element-Lock applies to its source or target design(s)."
    title="Don't externalize"
    token={"position-lock"}
    value={annotation.positionLock}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateAnnotation(event, "lock-position", annotation);
    }}
  />
</div>
<div class="pane-divider mt-5" />
<!-- Delete -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-button-row">
    <button
      on:click={(event) => {
        updateAnnotation("delete", "annotation", annotation);
        afterDelete();
      }}><i class="bi bi-eraser me-1" /> Delete this annotation</button
    >
  </div>
</div>
